import React, { HTMLAttributes } from "react";

export interface Heading2Props extends HTMLAttributes<HTMLHeadingElement> {
  emoji?: string;
}

const Heading2: React.FC<Heading2Props> = ({
  children,
  emoji = "",
  className = "",
  ...args
}) => {
  return (
    <h2
      className={`flex items-center text-3xl md:text-5xl font-semibold text-neutral-900 dark:text-neutral-100 text-center ${className}`}
      {...args}
    >
      {!!emoji && (
        <span className="">
          {emoji}
        </span>
      )}
      {children || `Heading2 Title`}
    </h2>
  );
};

export default Heading2;
